import { config } from "./config";

export const apiUrl = config.publicApiUrl;
